// src/hooks/useTheme.js
import { useThemeContext } from '../context/ThemeContext';

export const useTheme = () => {
  const context = useThemeContext();

  return {
    // legacy
    theme: context.theme,
    style: context.style,
    themeName: context.themeName,
    styleName: context.styleName,
    buttonVariantName: context.buttonVariantName,
    cardVariantName: context.cardVariantName,
    isDark: context.isDark,

    // new
    presetName: context.presetName,
    paletteName: context.paletteName,
    surfaceName: context.surfaceName,
    accentName: context.accentName,
    shadowPreset: context.shadowPreset,
    radiusPreset: context.radiusPreset,
    motionPreset: context.motionPreset,
    spacingPreset: context.spacingPreset,
    mode: context.mode,

    // config/features
    features: context.features,
    toggleFeature: context.toggleFeature,
    available: context.available,

    // preset action
    applyPreset: context.applyPreset,

    // actions legacy
    switchTheme: context.switchTheme,
    switchStyle: context.switchStyle,
    switchButtonVariant: context.switchButtonVariant,
    switchCardVariant: context.switchCardVariant,
    toggleDarkMode: context.toggleDarkMode,

    // actions new
    setPalette: context.setPalette,
    setSurface: context.setSurface,
    setAccent: context.setAccent,
    setDepth: context.setDepth,
    setShape: context.setShape,
    setMotion: context.setMotion,
    setSpacing: context.setSpacing,
    toggleMode: context.toggleMode,
    setMode: context.setMode,
    setButtonVariant: context.setButtonVariant,
    setCardVariant: context.setCardVariant,

    // config helpers
    resetConfig: context.resetConfig,
    exportConfig: context.exportConfig,
    importConfig: context.importConfig,

    // helpers
    getColor: context.getColor,
    getStyleProp: context.getStyleProp,
  };
};

export default useTheme;